import React, { useState } from "react";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Color from "../../../../../utils/Color";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomButton from "../../../../components/CustomButton";
import HelpIcon from "@material-ui/icons/Help";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";

const StyledTooltip = withStyles({
  tooltip: {
    color: Color.secondaryTextColor,
    backgroundColor: Color.backgroundColor,
    ...getFontWeight("normal"),
    ...getFontSize("small"),
  },
})(Tooltip);

const useStyles = makeStyles((theme) => ({
  tooltipContainer: {
    display: "flex",
  },
  infoIconStyle: {
    width: "20x",
    height: "20px",
    color: "#00B4AF",
    marginLeft: 10,
  },
  tooltipTextStyle: {
    color: Color.secondaryTextColor,
    ...getFontWeight("normal"),
    [theme.breakpoints.up("xs")]: {},
    [theme.breakpoints.up("lg")]: {
      width: 370,
      height: 80,
    },
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 35,
    marginBottom: 25,
    marginTop: 5,
  },
  headerTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
  },
  inputContentContainer: {
    marginTop: 5,
    marginBottom: 18,
  },
  buttonStyle: {
    width: 120,
    //marginBottom: 20,
  },
  highLightedTextStyle: {
    color: "#1858b9",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    // fontFamily: "Muli",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  descTextStyle: {
    color: "#818181",
    ...getFontSize("small"),
    ...getFontWeight("600"),
  },
  backButton: {
    width: 120,
    marginTop: 0,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
}));

function RegistrationForm({
  nric,
  onChangeNRIC,
  onClickNext,
  onClickContactUs,
  onClickBack,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

  const [selectedTooltip, setSelectedTooltip] = useState("");

  const handleTooltipOpen = (item) => {
    if (selectedTooltip !== item) {
      setSelectedTooltip(item);
    } else {
      setSelectedTooltip("");
    }
  };

  const renderTooltip = (item) => {
    if (!matchesMD) {
      return (
        <StyledTooltip
          title={
            <CustomText design={classes.tooltipTextStyle}>
              {<b>Note: </b>}Mobile number is your registered mobile number with
              us (same as Client Profile). If the number is not correct or have
              changed, please initiate a request from “Ask Etiqa” to update your
              mobile.
            </CustomText>
          }
          placement="right-start"
        >
          <HelpIcon className={classes.infoIconStyle} />
        </StyledTooltip>
      );
    } else {
      return (
        <div>
          <StyledTooltip
            PopperProps={{
              disablePortal: true,
            }}
            open={selectedTooltip === item}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={
              <CustomText design={classes.tooltipTextStyle}>
                {<b>Note: </b>}Mobile number is your registered mobile number
                with us (same as Client Profile). If the number is not correct
                or have changed, please initiate a request from “Ask Etiqa” to
                update your mobile.
              </CustomText>
            }
            placement={!matchesSM ? "right-start" : "bottom"}
          >
            <HelpIcon
              className={classes.infoIconStyle}
              onClick={() => handleTooltipOpen(item)}
            />
          </StyledTooltip>
        </div>
      );
    }
  };

  return (
    <div style={{marginTop:45}}>
      <CustomText design={classes.headerTextStyle}>
        Update Client Info
      </CustomText>
      <div className={classes.inputContentContainer}>
        <CustomTextInput
          title={"Name"}
          textstyle={classes.labelTextInputTextStyle}
          design={classes.textInputContainer}
          fullWidth={true}
          value={nric}
          onChange={onChangeNRIC}
          
        />
        <CustomTextInput
          title={"NRIC/Passport/FIN No."}
          textstyle={classes.labelTextInputTextStyle}
          design={classes.textInputContainer}
          fullWidth={true}
          value={nric}
          onChange={onChangeNRIC}
          //tooltip={renderTooltip("nric")}
        />
         <CustomTextInput
          title={"Email (as per registered email with Etiqa, if any)"}
          textstyle={classes.labelTextInputTextStyle}
          design={classes.textInputContainer}
          fullWidth={true}
          value={nric}
          onChange={onChangeNRIC}
        />
        <CustomTextInput
          title={"Mobile Number"}
          textstyle={classes.labelTextInputTextStyle}
          design={classes.textInputContainer}
          fullWidth={true}
          value={nric}
          onChange={onChangeNRIC}
        />
        <CustomTextInput
          title={"Date of Birth (in DDMMYYYY)"}
          textstyle={classes.labelTextInputTextStyle}
          design={classes.textInputContainer}
          fullWidth={true}
          value={nric}
          onChange={onChangeNRIC}
        />
      </div>
     
      

      {/* <CustomButton
        title={"Next"}
        design={classes.buttonStyle}
        onClick={onClickNext}
      />

      <CustomButton
        title={"Next"}
        design={classes.buttonStyle}
        onClick={onClickNext}
      /> */}

      <div style={{ paddingRight: "1em", display: "inline-block" }}>
        <CustomButton
          title={"Back"}
          design={classes.backButton}
          textstyle={classes.backButtonTextStyle}
          onClick={onClickBack}
        />
      </div>
      <div style={{ display: "inline-block" }}>
        <CustomButton
          title={"Submit"}
          design={classes.buttonStyle}
          onClick={onClickNext}
        />
      </div>

      <div style={{ marginTop: 15 }}>
        <CustomText design={classes.descTextStyle} component="div">
          If any of the information does not tally with your records with us,
          registration will fail. Please{" "}
          <CustomText
            display={"inline"}
            design={classes.highLightedTextStyle}
            onClick={onClickContactUs}
          >
            Contact Us{" "}
          </CustomText>
          for further assistance.
        </CustomText>
      </div>
    </div>
  );
}
export default RegistrationForm;
